import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewNotificationSettings } = appStoreLenses

export default viewNotificationSettings
